// @ts-nocheck
(function () {
  const $$ = (sel, root) => Array.prototype.slice.call((root || document).querySelectorAll(sel));
  const $ = (sel, root) => (root || document).querySelector(sel);

  function initProductThreeSection(sectionEl) {
    const tabs = $$('[data-product-three-tab]', sectionEl);
    const panels = $$('[data-product-three-panel]', sectionEl);
    const dots = $$('[data-product-three-dot]', sectionEl);
    if (tabs.length < 2 || panels.length < 2) return;

    let autoplayTimer = null;
    const AUTOPLAY_INTERVAL = 4000;

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(() => {
        const currentActive = tabs.find((t) => t.classList.contains('is-active'));
        const currentIndex = tabs.indexOf(currentActive);
        const nextIndex = (currentIndex + 1) % tabs.length;
        const which = tabs[nextIndex].getAttribute('data-product-three-tab');
        setActive(which);
      }, AUTOPLAY_INTERVAL);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function setActive(which, opts) {
      const focus = opts && opts.focus;
      const activeTab = tabs.find((t) => t.getAttribute('data-product-three-tab') === which);
      const activePanel = panels.find((p) => p.getAttribute('data-product-three-panel') === which);
      if (!activeTab || !activePanel) return;

      tabs.forEach((t) => {
        const on = t === activeTab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });

      panels.forEach((p) => {
        const on = p === activePanel;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', String(!on));
        if (on) p.removeAttribute('inert');
        else p.setAttribute('inert', '');
      });

      dots.forEach((d) => {
        const on = d.getAttribute('data-product-three-dot') === which;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', String(on));
        d.tabIndex = on ? 0 : -1;
      });

      if (focus) activeTab.focus();
    }

    setActive('left');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });
    }, { threshold: 0.2 });

    observer.observe(sectionEl);

    sectionEl.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest && (e.target.closest('[data-product-three-tab]') || e.target.closest('[data-product-three-dot]'));
      if (!btn) return;
      
      const which = btn.getAttribute('data-product-three-tab') || btn.getAttribute('data-product-three-dot');
      if (!which) return;
      
      setActive(which);
      stopAutoplay(); // Manual interaction stops autoplay
    });

    sectionEl.addEventListener('keydown', (e) => {
      const current = e.target && e.target.closest && (e.target.closest('[data-product-three-tab]') || e.target.closest('[data-product-three-dot]'));
      if (!current) return;
      const key = e.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      e.preventDefault();

      const idx = tabs.includes(current) ? tabs.indexOf(current) : dots.indexOf(current);
      if (idx < 0) return;

      let nextIdx = idx;
      if (key === 'ArrowLeft') nextIdx = (idx - 1 + tabs.length) % tabs.length;
      if (key === 'ArrowRight') nextIdx = (idx + 1) % tabs.length;
      if (key === 'Home') nextIdx = 0;
      if (key === 'End') nextIdx = tabs.length - 1;

      const next = tabs[nextIdx];
      const which = next && next.getAttribute('data-product-three-tab');
      if (!which) return;
      setActive(which, { focus: true });
      stopAutoplay(); // Keyboard interaction also stops autoplay
    });
  }

  function ensureSwiper(cb) {
    if (window.Swiper) return cb();
    // If the section added the Swiper loader, listen for readiness as well.
    const onReady = () => {
      if (!window.Swiper) return;
      document.removeEventListener('compound:swiper-ready', onReady);
      cb();
    };
    document.addEventListener('compound:swiper-ready', onReady);

    // Fallback: poll briefly in case Swiper is injected without emitting event.
    let tries = 0;
    const poll = () => {
      if (window.Swiper) return cb();
      tries += 1;
      if (tries > 80) return; // ~4s
      setTimeout(poll, 50);
    };
    poll();
  }

  function initProductMainTabs(sectionEl) {
    const tabs = $$('[data-product-main-tab]', sectionEl);
    const panels = $$('[data-product-main-panel]', sectionEl);
    if (tabs.length < 2 || panels.length < 2) return;

    function setActive(which, opts) {
      const focus = opts && opts.focus;
      const activeTab = tabs.find((t) => t.getAttribute('data-product-main-tab') === which);
      const activePanel = panels.find((p) => p.getAttribute('data-product-main-panel') === which);
      if (!activeTab || !activePanel) return;

      tabs.forEach((t) => {
        const on = t === activeTab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });

      panels.forEach((p) => {
        const on = p === activePanel;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', String(!on));
        if (on) p.removeAttribute('inert');
        else p.setAttribute('inert', '');
      });

      if (focus) activeTab.focus();
    }

    setActive(tabs[0].getAttribute('data-product-main-tab') || 'usage');

    sectionEl.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest && e.target.closest('[data-product-main-tab]');
      if (!btn) return;
      const which = btn.getAttribute('data-product-main-tab');
      if (!which) return;
      setActive(which);
    });

    sectionEl.addEventListener('keydown', (e) => {
      const current = e.target && e.target.closest && e.target.closest('[data-product-main-tab]');
      if (!current) return;
      const key = e.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      e.preventDefault();

      const idx = tabs.indexOf(current);
      if (idx < 0) return;

      let nextIdx = idx;
      if (key === 'ArrowLeft') nextIdx = (idx - 1 + tabs.length) % tabs.length;
      if (key === 'ArrowRight') nextIdx = (idx + 1) % tabs.length;
      if (key === 'Home') nextIdx = 0;
      if (key === 'End') nextIdx = tabs.length - 1;

      const next = tabs[nextIdx];
      const which = next && next.getAttribute('data-product-main-tab');
      if (!which) return;
      setActive(which, { focus: true });
    });
  }

  function initProductMainGallery(sectionEl) {
    const galleryEl = $('[data-product-main-gallery]', sectionEl);
    const thumbsEl = $('[data-product-main-thumbs]', sectionEl);
    if (!galleryEl || !thumbsEl) return;

    const isMobile = () =>
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(max-width: 991px)').matches;

    const getActiveVideoForSlide = (slide) => {
      if (!slide) return null;
      const role = isMobile() ? 'mobile' : 'desktop';
      const byRole = slide.querySelector('video[data-video-role="' + role + '"]');
      if (byRole) return byRole;
      // Fallback for older markup
      return $('video', slide);
    };

    const syncVideos = (activeIndex) => {
      const slides = $$('[data-product-main-slide]', galleryEl);
      slides.forEach((slide, idx) => {
        const video = getActiveVideoForSlide(slide);
        if (!video) return;
        const isActive = idx === activeIndex;
        const shouldAutoplay = slide.getAttribute('data-video-autoplay') !== 'false';
        if (!isActive) {
          try {
            video.pause();
            video.currentTime = 0;
          } catch (_) {}
          return;
        }
        if (!shouldAutoplay) return;
        try {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } catch (_) {}
      });
    };

    galleryEl.addEventListener('click', (e) => {
      const slide = e.target && e.target.closest && e.target.closest('[data-product-main-slide][data-media-type="video"]');
      if (!slide) return;
      const video = getActiveVideoForSlide(slide);
      if (!video) return;
      if (video.paused) {
        try {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } catch (_) {}
      } else {
        video.pause();
      }
    });

    // Swiper bundle (global) includes thumbs support.
    const thumbsSwiper = new window.Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      watchSlidesProgress: true,
    });

    const gallerySwiper = new window.Swiper(galleryEl, {
      slidesPerView: 1,
      speed: 450,
      keyboard: { enabled: true, onlyInViewport: true },
      thumbs: { swiper: thumbsSwiper },
      on: {
        init: (swiper) => syncVideos(swiper.activeIndex),
        slideChange: (swiper) => syncVideos(swiper.activeIndex),
      },
    });

    sectionEl.__productMainSwipers = { gallerySwiper, thumbsSwiper };
  }

  function initProductMainSection(sectionEl) {
    if (!sectionEl || sectionEl.__productMainInited) return;
    sectionEl.__productMainInited = true;

    initProductMainTabs(sectionEl);
    ensureSwiper(() => initProductMainGallery(sectionEl));

    // Sync simple variant <select> to ProductFormComponent hidden input.
    const variantSelect = $('[data-product-main-variant]', sectionEl);
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const hidden = sectionEl.querySelector('input[ref="variantId"][name="id"]');
        if (!hidden) return;
        hidden.value = variantSelect.value;
      });
    }
  }

  function init() {
    document.body && document.body.classList && document.body.classList.add('is-product');
    $$('[data-section="product-main"]').forEach((el) => initProductMainSection(el));
    $$('[data-section="product-three"]').forEach((el) => initProductThreeSection(el));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

